import { Directive, Output, EventEmitter, HostBinding, HostListener, Input, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../../@store/app.reducers';
import { MostrarMensajeAvisoAction } from '../../../@store/actions';


@Directive({ selector: '[dragDropMultipleFile]' })
export class DragDropMultipleFileDirective {

    @Input() inMutiple: boolean = false;
    @HostBinding('class.fileover') fileOver!: boolean;
    @Output() fileDropped = new EventEmitter<any>();

    private store: Store<AppState>

    constructor() { }

    // Dragover listener
    @HostListener('dragover', ['$event']) onDragOver(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        this.fileOver = true;
    }

    // Dragleave listener
    @HostListener('dragleave', ['$event']) public onDragLeave(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        this.fileOver = false;
    }

    // Drop listener
    @HostListener('drop', ['$event']) public ondrop(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        this.fileOver = false;
        let files = evt.dataTransfer.files;
        if (files.length > 0) {
            this.fileDropped.emit(files);
        } else {
            this.store.dispatch(MostrarMensajeAvisoAction({ titulo: 'Aviso', mensaje: 'Debes cargar al menos un archivo' }));
        }
    }
}